import { ChangeDetectionStrategy, Component, computed, inject, output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ThemeService } from '@ld.consumer-portal/utils';

@Component({
  selector: 'ld-forgot-password-success-card',
  imports: [TranslocoDirective],
  templateUrl: './forgot-password-success-card.component.html',
  styleUrl: './forgot-password-success-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordSuccessCardComponent {
  private readonly themeService = inject(ThemeService);

  protected logoUrl = computed(() => this.themeService.getLogoUrl());
  protected partnerDisplayName = computed(() => this.themeService.getPartnerDisplayName());

  tryAgain = output<void>();
  backToLogin = output<void>();

  protected onTryAgain(): void {
    this.tryAgain.emit();
  }

  protected onBackToLogin(): void {
    this.backToLogin.emit();
  }
}
